// extracted by mini-css-extract-plugin
module.exports = {"order":"OrderList_order_1koMT","image":"OrderList_image_MbK1A","info":"OrderList_info_3CU0Z","sensor":"OrderList_sensor_1tKQk","details":"OrderList_details_qj-kV"};